module.exports = __webpack_public_path__ + "assets/img/btn-download-xbox-a87c476e.png";